// Original theme:
// https://github.com/FormidableLabs/prism-react-renderer/blob/master/src/themes/nightOwlLight.js
import type { PrismTheme } from "prism-react-renderer";

const theme: PrismTheme = {
  plain: {
    color: "#403f53",
    backgroundColor: "#F9F9F9",
  },
  styles: [
    {
      types: ["changed"],
      style: {
        // Standard color from Night Owl theme
        color: "rgb(162, 191, 252)",
        fontStyle: "italic",
      },
    },
    {
      types: ["deleted"],
      style: {
        // Standard color from Night Owl theme
        color: "rgba(239, 83, 80, 0.56)",
        fontStyle: "italic",
      },
    },
    {
      types: ["inserted", "attr-name"],
      style: {
        // fiberblue
        color: "#4A78FF",
        fontStyle: "italic",
      },
    },
    {
      types: ["comment"],
      style: {
        // fibercomment
        color: "#a4a4a4",
        fontStyle: "italic",
      },
    },
    {
      types: ["string", "builtin", "char", "constant", "url"],
      style: {
        // fiberblue
        color: "#4A78FF",
      },
    },
    {
      types: ["variable"],
      style: {
        color: "rgb(201, 103, 101)",
      },
    },
    {
      types: ["number"],
      style: {
        // fiberpinkypurple
        color: "#9674FD",
      },
    },
    {
      // This was manually added after the auto-generation
      // so that punctuations are not italicised
      types: ["punctuation"],
      style: {
        // fiberpurple
        color: "#D805C3",
      },
    },
    {
      types: ["function", "selector", "doctype"],
      style: {
        fontStyle: "italic",
        // fiberdarkerpurple
        color: "#7C51FC",
      },
    },
    {
      types: ["class-name"],
      style: {
        // Standard color from Night Owl theme
        color: "rgb(17, 17, 17)",
      },
    },
    {
      types: ["tag"],
      style: {
        // Standard color from Night Owl theme
        color: "rgb(153, 76, 195)",
      },
    },
    {
      types: ["operator", "property", "keyword", "namespace"],
      style: {
        // fibergreen
        color: "var(--color-green)",
      },
    },
    {
      types: ["boolean"],
      style: {
        // fiberburntorange
        color: "#FD6644",
      },
    },
  ],
};

export default theme;
